"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRDT_CONSTANTS = void 0;
var CRDT_CONSTANTS;
(function (CRDT_CONSTANTS) {
    CRDT_CONSTANTS[CRDT_CONSTANTS["MAX_TUPLE_LENGTH"] = 255] = "MAX_TUPLE_LENGTH";
})(CRDT_CONSTANTS || (exports.CRDT_CONSTANTS = CRDT_CONSTANTS = {}));
